import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const FooterContainer = styled.footer`
  padding: 2rem;
  background-color: #f8f9fa;
  text-align: center;
  margin-top: auto;
  width: 100%;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const LinksContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
`;

const FooterLink = styled(Link)`
  color: #3182CE;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
  
  &:hover {
    color: #2B6CB0;
    text-decoration: underline;
  }
`;

const FeedbackLink = styled.a`
  display: inline-flex;
  align-items: center;
  color: #3182CE;
  font-size: 0.9rem;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #2B6CB0;
    text-decoration: underline;
  }
`;

const Copyright = styled.p`
  font-size: 0.875rem;
  color: #718096;
  margin: 0;
`;

const Footer: React.FC = () => {
  const { language } = useLanguage();
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <LinksContainer>
          <FooterLink to="/privacy-policy">
            {language === 'zh' ? '隐私政策' : 'Privacy Policy'}
          </FooterLink>
          <FeedbackLink href="mailto:sheetmate.ai@gmail.com">
            {language === 'zh' ? '反馈与建议' : 'Feedback & Suggestions'}
          </FeedbackLink>
        </LinksContainer>
        <Copyright>
          © {currentYear} SheetMate {language === 'zh' ? '版权所有' : 'All Rights Reserved'}
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 